import Vue from 'vue';

const formatMoney = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
}).format;

Vue.filter('formatMoney', formatMoney);

window.formatMoney = formatMoney;
